module.exports = __webpack_public_path__ + "img/Social Networker.3d3b4b7a.svg";